import React, { Component } from "react";
import * as d3 from "d3";
import $ from "jquery";
import PropTypes from "prop-types";
import "./drillDown.scss";

class DrillDown extends Component {
  componentDidMount() {
    const {
      id,
      chartData,
      chartOptions,
      width,
      height,
      defaultDrillView,
    } = this.props;

    // const getShortSymbol = (str) => {
    //   if (str.length < 5) return str;
    //   return str.replace(/\b(\w{1,2})(\w+\s?|\s)/g, "$1 ").slice(0, -1);
    // };

    let Plot;
    let condition = false;

    if (chartOptions && chartOptions.length) {
      if (Object.keys(chartOptions[0]["captions"][0]).length === 1) {
        condition = true;
      } else {
        condition = false;
      }
    }
    if (defaultDrillView === true && condition) {
      Plot = () => {
        var rd = this.TransformChartData({
          chartData,
          opts: chartOptions,
          level: 1,
          filter: chartData[0]["Country"],
        });
        this.BuildPie({
          id,
          chartData,
          chartOptions,
          level: 1,
          runningData: rd[0],
          runningColors: rd[1],
          width,
          height,
        });
      };
    } else {
      Plot = () => {
        var rd = this.TransformChartData({
          chartData,
          opts: chartOptions,
          level: 0,
        });
        this.BuildPie({
          id,
          chartData,
          chartOptions,
          level: 0,
          runningData: rd[0],
          runningColors: rd[1],
          width,
          height,
        });
      };
    }

    Plot();
  }
  componentWillReceiveProps(nextProps) {
    const { chartData } = nextProps;
    if (
      this.props.chartData &&
      chartData &&
      JSON.stringify(this.props.chartData) !== JSON.stringify(chartData)
    ) {
      const { id, chartOptions, width, height } = nextProps;

      const Plot = () => {
        var rd = this.TransformChartData({
          chartData,
          opts: chartOptions,
          level: 0,
        });
        this.BuildPie({
          id,
          chartData,
          chartOptions,
          level: 0,
          runningData: rd[0],
          runningColors: rd[1],
          width,
          height,
        });
      };
      Plot();
    }
  }
  TransformChartData = ({ chartData, opts, level, filter }) => {
    let result = [];
    let resultColors = [];
    let counter = 0;
    let hasMatch;
    let xVarName;
    let yVarName = opts[0].yaxis;

    if (level === 1) {
      xVarName = opts[0].xaxisl1;
      for (let i in chartData) {
        hasMatch = false;
        for (let index = 0; index < result.length; ++index) {
          let data = result[index];

          if (
            data[xVarName] === chartData[i][xVarName] &&
            chartData[i][opts[0].xaxis] === filter
          ) {
            result[index][yVarName] =
              result[index][yVarName] + chartData[i][yVarName];
            hasMatch = true;
            break;
          }
        }
        if (hasMatch === false && chartData[i][opts[0].xaxis] === filter) {
          if (result.length < 9) {
            let ditem = {};
            ditem[xVarName] = chartData[i][xVarName];
            ditem[yVarName] = chartData[i][yVarName];
            ditem["caption"] = chartData[i][xVarName].substring(0, 70);
            ditem["title"] = chartData[i][xVarName];
            ditem["op"] = 1.0 - parseFloat("0." + result.length);
            result.push(ditem);

            resultColors[counter] =
              opts[0].color[0][chartData[i][opts[0].xaxis]];

            counter += 1;
          }
        }
      }
    } else {
      xVarName = opts[0].xaxis;
      for (let j in chartData) {
        hasMatch = false;
        for (let indx = 0; indx < result.length; ++indx) {
          let data = result[indx];

          if (data[xVarName] === chartData[j][xVarName]) {
            result[indx][yVarName] =
              result[indx][yVarName] + chartData[j][yVarName];
            hasMatch = true;
            break;
          }
        }
        if (hasMatch === false) {
          let ditem = {};
          ditem[xVarName] = chartData[j][xVarName];
          ditem[yVarName] = chartData[j][yVarName];
          ditem["caption"] =
            opts[0].captions !== undefined
              ? opts[0].captions[0][chartData[j][xVarName]]
              : "";
          ditem["title"] =
            opts[0].captions !== undefined
              ? opts[0].captions[0][chartData[j][xVarName]]
              : "";
          ditem["op"] = 1;
          result.push(ditem);

          resultColors[counter] =
            opts[0].color !== undefined
              ? opts[0].color[0][chartData[j][xVarName]]
              : "";

          counter += 1;
        }
      }
    }
    return [result, resultColors];
  };

  BuildPie = ({
    id,
    chartData,
    chartOptions,
    level,
    runningData,
    runningColors,
    width,
    height,
  }) => {
    let xVarName;
    let previousY = 0;
    let previousTextY = 0;
    const Y_OFFSET = 15;
    let chartInnerDiv =
      '<div class="innerCont" style="overflow: auto;top:1px; left: 1px; height:91% ; Width:100% ;position: relative;overflow: auto;text-align:center"/>';

    d3.selectAll(`#${id} ${".innerCont"}`).remove();

    $("#" + id).append(chartInnerDiv);
    let chart = d3.select("#" + id + " .innerCont");
    let yVarName = chartOptions[0].yaxis;
    let radius = Math.min(width, height) / 2.3;

    if (level === 1) {
      xVarName = chartOptions[0].xaxisl1;
    } else {
      xVarName = chartOptions[0].xaxis;
    }

    let rcolor = d3.scale.ordinal().range(runningColors);
    let arc = d3.svg
      .arc()
      .outerRadius(radius * 0.8)
      .innerRadius(0);

    let arcOver = d3.svg
      .arc()
      .outerRadius(radius * 0.9)
      .innerRadius(radius * 0.9);

    let arcMouseON = d3.svg
      .arc()
      .outerRadius(radius)
      .innerRadius(radius - width / 2);

    chart = chart
      .append("svg")
      .attr("viewBox", `0 0 ${width} ${height}`)
      .append("g")
      .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

    // var chart2 = d3.select("#" + id + " .innerCont");
    // chart2 = chart2
    //   .append("div")
    //   .attr("width", width)
    //   .attr("height", height / 1.2)
    //   .append("div")
    //   .attr("class", "legendPie-parent")
    //   .attr(
    //     "transform",
    //     "translate(" +
    //       width / divisionRatio +
    //       "," +
    //       (height / divisionRatio + 50) +
    //       ")"
    //   );

    const pie = d3.layout
      .pie()
      .sort(null)
      .value((d) => d.Total);

    const g = chart
      .selectAll(".arc")
      .data(pie(runningData))
      .enter()
      .append("g")
      .attr("class", "arc");

    let count = 0;

    //********* polylines ************

    chart.append("g").attr("class", "lines");

    const polyline = chart
      .select(".lines")
      .selectAll("polyline")
      .data(pie(runningData), key);

    polyline
      .enter()
      .append("polyline")
      .style("fill", "none")
      .style("stroke-width", ".8")
      .style("stroke", "#252474");

    function midAngle(d) {
      return d.startAngle + (d.endAngle - d.startAngle) / 2;
    }

    // dummy arc for vale lesser than 1.5
    // const arc_lowerRange = d3.svg
    //   .arc()
    //   .outerRadius(radius * 1.2)
    //   .innerRadius(0);

    polyline
      .transition()
      .duration(0)
      .attrTween("points", function (d) {
        this._current = this._current || d;
        let interpolate = d3.interpolate(this._current, d);
        this._current = interpolate(0);
        return function (t) {
          let d2 = interpolate(t);

          let pos = arcOver.centroid(d2);
          pos[0] = radius * 0.95 * (midAngle(d2) < Math.PI ? 1 : -1);

          let pointB = arcOver.centroid(d2);
          let pointC = pos;

          if (Math.abs(pointB[1] - previousY) < Y_OFFSET) {
            let diff = Y_OFFSET - Math.abs(pointB[1] - previousY);
            pointB[1] = pointB[1] - diff;
            pointC[1] = pointB[1];
          }
          previousY = arcOver.centroid(d2)[1];
          return [arc.centroid(d2), pointB, pointC];
        };
      });

    polyline.exit().remove();
    // ********** polyline end *******

    let path = g
      .append("path")
      .attr("d", arc)
      .attr("id", function (d) {
        return "arc-" + count++;
      })
      .style("opacity", (d) => d.data["op"]);

    path
      .on("mouseenter", function (d) {
        d3.select(this)
          .attr("stroke", "white")
          .transition()
          .duration(200)
          .attr("d", arcMouseON)
          .attr("stroke-width", 2);
      })
      .on("mouseleave", function (d) {
        d3.select(this)
          .transition()
          .duration(200)
          .attr("d", arc)
          .attr("stroke", "none");
      })
      .on("click", (d) => {
        if (this._listenToEvents) {
          // Reset inmediatelly
          d3.select(this).attr("transform", "translate(0,0)");

          // Change level on click if no transition has started
          path.each(function () {
            this._listenToEvents = false;
          });
        }
        d3.selectAll("#" + id + " svg").remove();
        if (level === 1) {
          let rd = this.TransformChartData({
            chartData,
            opts: chartOptions,
            level: 0,
            filter: d.data[xVarName],
          });
          this.BuildPie({
            id,
            chartData,
            chartOptions,
            level: 0,
            runningData: rd[0],
            runningColors: rd[1],
            width,
            height,
          });
        } else {
          var nonSortedChart = chartData.sort(function (a, b) {
            return (
              parseFloat(b[chartOptions[0].yaxis]) -
              parseFloat(a[chartOptions[0].yaxis])
            );
          });
          let rd = this.TransformChartData({
            chartData: nonSortedChart,
            opts: chartOptions,
            level: 1,
            filter: d.data[xVarName],
          });
          this.BuildPie({
            id,
            chartData: nonSortedChart,
            chartOptions,
            level: 1,
            runningData: rd[0],
            runningColors: rd[1],
            width,
            height,
          });
        }
      });
    //******** outer labels ***********

    const key = function (d) {
      return d.data.Country || d.data.Model;
    };

    chart.append("g").attr("class", "labels");

    let txt = chart
      .select(".labels")
      .selectAll("text")
      .data(pie(runningData), key);

    let fsize = function (d) {
      if (d.data.Country) {
        return d.data.Country.length > 25 ? "8px" : "10px";
      } else if (d.data.Model) {
        return d.data.Model.length > 25 ? "8px" : "10px";
      }
    };
    txt
      .enter()
      .append("text")
      .attr("dy", ".35em")
      .style("font-size", fsize)
      .style("fill", "#252474")
      .style("font-weight", "bold")
      .text(function (d) {
        // if(d.data.Country){
        //   return getShortSymbol(d.data.Country);
        // }
        // else{
        //   return getShortSymbol(d.data.Model);
        // }

        return d.data.Country || d.data.Model;
      });

    txt
      .transition()
      .duration(0)
      .attrTween("transform", function (d) {
        this._current = this._current || d;
        let interpolate = d3.interpolate(this._current, d);
        this._current = interpolate(0);
        return function (t) {
          let d2 = interpolate(t);
          let pos = arcOver.centroid(d2);
          pos[0] = radius * (midAngle(d2) < Math.PI ? 1 : -1);
          if (Math.abs(pos[1] - previousTextY) < Y_OFFSET) {
            let diff = Y_OFFSET - Math.abs(pos[1] - previousTextY);
            pos[1] = pos[1] - diff;
          }
          previousTextY = pos[1];
          return "translate(" + pos + ")";
        };
      })
      .styleTween("text-anchor", function (d) {
        this._current = this._current || d;
        let interpolate = d3.interpolate(this._current, d);
        this._current = interpolate(0);
        return function (t) {
          let d2 = interpolate(t);
          return midAngle(d2) < Math.PI ? "start" : "end";
        };
      });

    txt.exit().remove();

    //*** path title and inner label ***

    let inner_text = chart
      .selectAll(".innerText")
      .data(pie(runningData))
      .enter()
      .append("g")
      .attr("class", "innerText");

    path
      .append("svg:title")
      .text(function (d) {
        return d.data["title"] + " (" + d.data[yVarName].toFixed(1) + "%" + ")";
      })
      .style("fill", "none")
      .style("stroke", "#fff")
      .style("stroke-width", 0.75);
    path
      .style("fill", (d) => rcolor(d.data[xVarName]))
      .transition()
      .duration(1000)
      .attrTween("d", tweenIn)
      .each("end", function () {
        this._listenToEvents = true;
      });

    inner_text
      .append("text")
      .attr("transform", function (d) {
        var _d = arc.centroid(d);
        _d[0] *= 1.5;
        _d[1] *= 1.5;
        return "translate(" + _d + ")";
      })
      .attr("dy", ".35em")
      .style("font-size", "10px")
      .style("text-anchor", "middle")
      .style("opacity", 1)
      .style("fill", "#fff")
      .style("font-weight", "bold")
      .text(function (d) {
        return d.data[yVarName].toFixed(1) + "%";
      });
    count = 0;

    // ************ legend ************

    // var legend = chart2
    //   .selectAll(".legendPie")
    //   .data(runningData)
    //   .enter()
    //   .append("div")
    //   .attr("class", "legendPie")
    //   .attr("legend-id", d => count++)
    //   .style("cursor", "pointer")
    //   .on("click", function() {
    //     var oarc = d3.select("#" + id + " #arc-" + $(this).attr("legend-id"));
    //     oarc
    //       .style("opacity", 0.3)
    //       .attr("stroke", "white")
    //       .transition()
    //       .duration(200)
    //       .attr("d", arcOver)
    //       .attr("stroke-width", 1);
    //     setTimeout(function() {
    //       oarc
    //         .style("opacity", function(d) {
    //           return d.data["op"];
    //         })
    //         .attr("d", arc)
    //         .transition()
    //         .duration(200)
    //         .attr("stroke", "none");
    //     }, 1000);
    //   });

    // var leg = legend.append("span");
    // leg
    //   // .attr("x", width / 2)
    //   // .attr("width", 18)
    //   // .attr("height", 18)
    //   .text("● ")
    //   .style("color", d => rcolor(d[yVarName]))
    //   .style("opacity", d => d["op"])
    //   .style("font-size", "20px");

    // legend
    //   .append("span")
    //   // .attr("x", width / 2 - 5)
    //   // .attr("y", 9)
    //   .attr("dy", ".35em")
    //   .style("text-anchor", "end")
    //   .text(function(d) {
    //     return d.caption;
    //   });
    // leg.append("svg:title").text(function(d) {
    //   return d["title"] + " (" + d[yVarName] + ")";
    // });

    function tweenIn(data) {
      let interpolation = d3.interpolate(
        {
          startAngle: 0,
          endAngle: 0,
        },
        data
      );
      this._current = interpolation(0);
      return function (t) {
        return arc(interpolation(t));
      };
    }
  };

  render() {
    const { id } = this.props;
    return (
      <div id={id}>
        {/* <div
          className="innerCont"
          style={{
            overflow: "auto",
            top: "100px",
            left: "40px",
            height: "91%",
            width: "100%",
            position: "relative",
            overflow: "auto",
            textAlign: "center"
          }}
        /> */}
      </div>
    );
  }
}

DrillDown.propTypes = {
  id: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  idInner: PropTypes.string.isRequired,
  chartData: PropTypes.arrayOf(
    PropTypes.shape({
      Country: PropTypes.string.isRequired,
      Model: PropTypes.string.isRequired,
      Total: PropTypes.number.isRequired,
    })
  ).isRequired,
  chartOptions: PropTypes.arrayOf(
    PropTypes.shape({
      caption: PropTypes.arrayOf(PropTypes.object),
      color: PropTypes.arrayOf(PropTypes.object),
      xaxis: PropTypes.string,
      xaxisl1: PropTypes.string,
      yaxis: PropTypes.string,
    })
  ),
};
export default DrillDown;



// WEBPACK FOOTER //
// ./src/components/d3Components/drillDownPie/drillDown.js